document.addEventListener('DOMContentLoaded', function () {
  function getSwatchHandles() {
    return Array.isArray(window.SWATCH_HANDLES) ? window.SWATCH_HANDLES : [];
  }

  function cartHasOnlySwatches(cart) {
    const swatchHandles = getSwatchHandles();
    if (!cart.items || !cart.items.length) return false;

    let hasNonSwatch = false;

    cart.items.forEach(item => {
      if (!swatchHandles.includes(item.handle)) {
        hasNonSwatch = true;
      }
    });

    return cart.item_count > 0 && !hasNonSwatch;
  }

  function showSwatchOnlyState() {
    const msg = document.getElementById('swatch-only-message');
    const checkoutBtn = document.getElementById('cart-drawer-checkout-button');
    const expressBtns = document.getElementById('cart-drawer-express-buttons');

    if (msg) msg.style.display = 'block';

    if (checkoutBtn) {
      checkoutBtn.disabled = true;
      checkoutBtn.style.opacity = '0.5';
      checkoutBtn.style.pointerEvents = 'none';
    }

    if (expressBtns) {
      expressBtns.style.display = 'none';
    }
  }

  function hideSwatchOnlyState() {
    const msg = document.getElementById('swatch-only-message');
    const checkoutBtn = document.getElementById('cart-drawer-checkout-button');
    const expressBtns = document.getElementById('cart-drawer-express-buttons');

    if (msg) msg.style.display = 'none';

    if (checkoutBtn) {
      checkoutBtn.disabled = false;
      checkoutBtn.style.opacity = '';
      checkoutBtn.style.pointerEvents = '';
    }

    if (expressBtns) {
      expressBtns.style.display = '';
    }
  }

  async function refreshGuard() {
    try {
      const res = await fetch('/cart.js', { credentials: 'same-origin' });
      const cart = await res.json();

      if (cartHasOnlySwatches(cart)) {
        showSwatchOnlyState();
      } else {
        hideSwatchOnlyState();
      }
    } catch (err) {
      console.error('Swatch guard error:', err);
    }
  }

  document.addEventListener('click', async function (e) {
    const checkoutBtn = e.target.closest(
      '#cart-drawer-checkout-button, .additional-checkout-buttons a, .additional-checkout-buttons button'
    );

    if (!checkoutBtn) return;

    try {
      const res = await fetch('/cart.js', { credentials: 'same-origin' });
      const cart = await res.json();

      if (cartHasOnlySwatches(cart)) {
        e.preventDefault();
        e.stopPropagation();
        showSwatchOnlyState();
      }
    } catch (err) {
      console.error(err);
    }
  }, true);

  refreshGuard();

  document.addEventListener('cart:refresh', refreshGuard);
  document.addEventListener('cart:updated', refreshGuard);
});